<template>
  <div class="container" v-bind:class="designClassName">
    <div class="container-inner">
      <component :is="currentComponent" :key="currentComponentKey"></component>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// 最後消す

import Default from './components/Default.vue'
import NotFound from './components/NotFound.vue'
import EntryTerminate from './components/EntryTerminate.vue'
import EntryQuestionWait from './components/EntryQuestionWait.vue'
import EntryQuestionWaitFirst from './components/EntryQuestionWaitFirst.vue'
import EntryQuestion from './components/EntryQuestion.vue'
import CompleteSession from './components/CompleteSession.vue'
import EntryAnswerResultWait from './components/EntryAnswerResultWait.vue'
import axios from 'axios';
import sha256 from 'crypto-js/sha256';

function isEmpty(obj){
  return !Object.keys(obj).length;
}

export default {
  name: 'App',
  components: {
    Default,
    NotFound,
    EntryTerminate,
    EntryQuestionWait,
    EntryQuestionWaitFirst,
    EntryQuestion,
    CompleteSession,
    EntryAnswerResultWait,
  },
  data() {
    // return initialState()
    return {
      designClassName: '',
      voteScreanInfo: [],
      currentComponent: 'Default',
      fileCreatedAt: '',
      publishedAt: '',
      error: [],
      timerId: '',
      programCookieKey: '',
      currentComponentKey: 0,
    }
  },
  provide() {
    return {
      voteScreanInfo: this.voteScreanInfo,
      getJson: this.getJson,
      viewScrean: this.viewScrean,
      encryptSha256: this.encryptSha256,
      getUrlKey: this.getUrlKey,
      error: this.error,
      getReservedWord: this.getReservedWord,
      clearTimer: this.clearTimer,
    }
  },
  mounted(){ // ページが読み込まれたらする処理

    // クッキーコンフィグ設定
    // this.$cookies.config('7d');

    this.getJson();

    // 時間でデータ取得処理を繰り返し
    this.timerId = setInterval(
      () => {
        Object.assign(this.$data.voteScreanInfo, []);
        this.getJson()
      }, 1500);

    // this.clearTimer();
    
    // 同じタブでブラウザバックや矢印ボタン遷移された場合リロードをかける
    window.onpageshow = function(event) {
        // console.log(event);
      // キャッシュが残っていたら
      if (event.persisted) {
        // console.log('reload');
        window.location.reload();
      }
    };

  },
  methods: { // 使い回す関数

    getJson(error = null) { // 投票画面情報ファイル取得
      // console.log('getJson');

      this.error.splice(0);
      this.error.push(error);

      this.voteScreanInfo.splice(0); // dataに定義した配列をリアクティブで空にする
      var host = location.host;
      var locPathname = location.pathname;
      var pathname = locPathname.substring(0, locPathname.lastIndexOf('/')) + '/';
      var dateTime = this.getDateTime();
      if(host.indexOf('localhost') > -1) {
        var voteJsonPath = './vote_screen_information.json?' + dateTime;
      } else {
        var voteJsonPath = pathname + 'vote_screen_information.json?' + dateTime;
      }

      axios
      .get(voteJsonPath, {
        headers: {
            'Cache-Control': 'no-cache',
        },
      })
      .then(
        response => {
          // console.log(response);
          this.voteScreanInfo.push(response.data);

          // ポーリング停止処理
          if(this.voteScreanInfo[0].basic_info.program_public_status === 1) {
            this.clearTimer();
            this.viewScrean(false);
            return;
          }

          // ファイル生成日時が変わっている場合画面更新
          if(this.fileCreatedAt != this.voteScreanInfo[0].file_created_at) {
            this.fileCreatedAt = this.voteScreanInfo[0].file_created_at;
            this.currentComponentKey += 1;
          }

            this.viewScrean(true);

        }
      )
      .catch(
        error => {
          // console.log('データを取得できませんでした');
          // console.log(error);
          this.viewScrean(false);
        }
      )
      .finally();
    },

    viewScrean(status) { //画面振り分け表示
      //console.log(this.voteScreanInfo[0]);

      // 投票データが取れなかった場合はNotFoundを表示
      if(status == false) {
        // console.log('エラー画面');
        // document.location.href = 'https://www.nhk.or.jp/toppage/errors/not_found.html?vote';
        this.currentComponent = 'NotFound';
        return;
      }

      var basicInfo = this.voteScreanInfo[0].basic_info;
      var displayInfo = this.voteScreanInfo[0].display_info;
      var questionInfo = this.voteScreanInfo[0].question_info;

      if(displayInfo.common_setting_information.design_pattern) {
        this.designClassName = 'design'+displayInfo.common_setting_information.design_pattern;
      }

      // 設問更新時間をCookieにセット
      this.programCookieKey ='nhk_'+ basicInfo.program_frame_id + '_' + basicInfo.program_id;
      var cookieData = this.$cookies.get(this.programCookieKey);

      // this.questionSettingUpdatedAt = this.voteScreanInfo[0].question_setting_updated_at;
      this.publishedAt = this.voteScreanInfo[0].published_at;

      if(cookieData) {
        // 特定の条件でCookieクリア
        if(cookieData.published_at) {
          if(cookieData.published_at != this.publishedAt) {
            // console.log('Cookie削除');
            $cookies.remove(this.programCookieKey);
          }
        }
      } else {
        var cookieDataArray = {
          'published_at': this.publishedAt,
        }
        var cookieDataString = JSON.stringify(cookieDataArray);
        this.$cookies.set(this.programCookieKey, cookieDataString, '7d');
      }
      cookieData = this.$cookies.get(this.programCookieKey);

      //var nowQuestionNum = reservedWord.now_question_num > 0 ? reservedWord.now_question_num - 1 : 0;
      var reservedWord = this.voteScreanInfo[0].reserved_word;
      var nowQuestion = questionInfo.length ? questionInfo[0] : {};
      var nowQuestionNum = nowQuestion.question_no ? nowQuestion.question_no : 0;
      // 今公開中の設問に答えてるかどうか判定
      var nowQuestionAnswerd = false;
      var isEmptyObject = isEmpty(nowQuestion);

      // console.log('cookie取得 screen');
      // console.log(cookieData);

      //オブジェクトが空じゃなかったら（設問公開中、クッキーデータあり（何かしら回答してる））
      if(isEmptyObject == false && cookieData) {
        var answeredQuestionNum = cookieData.answered_question_num
        if(answeredQuestionNum && answeredQuestionNum.indexOf(nowQuestion.question_no) > -1) {
          nowQuestionAnswerd = true;
        }
      }


      // 番組が公開中（終了画面表示）
      if(basicInfo.program_public_status == 4 && !cookieData.is_last) {
        // console.log('投票企画終了画面');
        this.currentComponent = 'EntryTerminate';
        return;
      }

      /************************************************
       * アンケードモード
       ************************************************/

      if(basicInfo.mode == 1) {

        // 番組公開ステータスが公開中。「設問開始待ち画面」「受付中」
        if(basicInfo.program_public_status == 3) {

          // 設問開始待ち画面(1問目)
          if(
            !questionInfo.length && !cookieData.is_last && reservedWord.now_question_num === 1
          ) {
            // console.log('設問開始待ち画面1問目');
            this.currentComponent = 'EntryQuestionWaitFirst';
            return;
          }

          // 設問開始待ち画面
          if(
            !questionInfo.length && !cookieData.is_last
            || questionInfo.length && nowQuestionAnswerd == true && basicInfo.can_multiple_vote == 0 && !cookieData.is_last
          ) {
            // console.log('設問開始待ち画面');
            this.currentComponent = 'EntryQuestionWait';
            return;
          }

          // 設問受付中
          if(questionInfo.length > 0 && nowQuestion.question_public_status == 1) {
            if( nowQuestionAnswerd == false
              || basicInfo.can_multiple_vote == 1
            ) {

              // console.log('設問受付中');
              this.currentComponent = 'EntryQuestion';
              // clearInterval(this.timerId);
              return;
            }
          }

        }

        // 完了画面
        if(cookieData.is_last && basicInfo.can_multiple_vote == 0
          || basicInfo.program_public_status == 4 && cookieData.is_last
          || !questionInfo.length && cookieData.is_last
        ) {
          // console.log('完了画面');
          this.currentComponent = 'CompleteSession';
          return;
        }


      } else if(basicInfo.mode == 2) {

        /************************************************
         * クイズモード 
         ************************************************/


        // 番組公開ステータスが公開中。「設問開始待ち画面」「受付中」「解答結果待ち画面」
        if(basicInfo.program_public_status == 3) {

          // 設問開始待ち画面(1問目)
          if(
            !questionInfo.length && !cookieData.is_last && reservedWord.now_question_num === 1
          ) {
            // console.log('設問開始待ち画面1問目');
            this.currentComponent = 'EntryQuestionWaitFirst';
            return;
          }

          // 設問開始待ち画面
          if(
            !questionInfo.length && !cookieData.is_last
            || nowQuestion.question_public_status != 1 && nowQuestion.question_public_status != 3 && !cookieData.is_last
            || nowQuestionAnswerd == false && nowQuestion.question_public_status == 3
          ) {
            // console.log('設問開始待ち画面');
            this.currentComponent = 'EntryQuestionWait';
            return;
          }

          // 設問受付中
          if(questionInfo.length > 0 && nowQuestion.question_public_status == 1) {
            if(nowQuestionAnswerd == false) {
              // console.log('設問受付中');
              this.currentComponent = 'EntryQuestion';
              return;
            }
          }

          // 解答結果待ち画面
          if(
            questionInfo.length > 0 && nowQuestionAnswerd == true && nowQuestion.question_public_status != 4
          ) {
            // console.log('解答結果待ち画面');
            this.currentComponent = 'EntryAnswerResultWait';
            return;
          }

        }

        // 完了画面
        if(cookieData.is_last
          || basicInfo.program_public_status == 4 && cookieData.is_last
        ) {
          // console.log('完了画面');
          this.currentComponent = 'CompleteSession';
          return;
        }

      }

    },

    restData() {
      Object.assign(this.$data, initialState());
    },

    encryptSha256(str) {
      return sha256(str);
    },

    getUrlKey() {
      var urlKey = '';
      var host = location.host;
      var pathname = location.pathname;
      // var pathname = '/tohyo/BDHeo8T3RJ/'; // prod
      // var pathname = '/tohyo/r/hogehoge/BDHeo8T3RJ/'; // rehearsal
      var pathArray = [];

      // localhotだったら
      if(host.indexOf('localhost') > -1) {
        // urlKey = 'BDHeo8T3RJ';
        urlKey = 'BDHeo8T3RJ';
      } else {
        // 本番・リハーサル

        var splitedPathname = pathname.split('/');
        for(const path of splitedPathname) {
          if(path) {
            pathArray.push(path);
          }
        }

        if(pathArray.indexOf('r') > -1) { //リハーサルサイトだったら
          urlKey = pathArray[3];
        } else {
          urlKey = pathArray[1];
        }
      }

      // console.log('URLキー');
      // console.log(urlKey);
      return urlKey;
    },

    getDateTime() {
      var now = new Date();
      var Year = now.getFullYear();
      var Month = ("0"+(now.getMonth() + 1)).slice(-2);
      var Day = ("0"+now.getDate()).slice(-2);
      var Hour = now.getHours();
      var Min = ("0"+now.getMinutes()).slice(-2);
      var Sec = ("0"+now.getSeconds()).slice(-2);
      var dateTime = '' + Year + Month + Day + Hour + Min + Sec;
      // var dateTime = '' + Year + '/' + Month + '/' + Day + '^' + Hour + ':' + Min + ':' + Sec;
      return dateTime;
    },

    getReservedWord(text) {
      if(!text) return;

      var reservedWord = this.voteScreanInfo[0].reserved_word;
      var questionInfo = this.voteScreanInfo[0].question_info;
      var questionPublicStatus = !!questionInfo.length ? questionInfo[0].question_public_status : 0;
      var questionNo = !!questionInfo.length ? questionInfo[0].question_no : 0;
      var cookieData = this.$cookies.get(this.programCookieKey);

      var text = text.replace(/\$TOTAL_QUESTION_NUM\$/g, reservedWord.all_question_num);
      text = text.replace(/\$CURRENT_QUESTION_NUM\$/g, reservedWord.now_question_num);
      text = text.replace(/\$TOTAL_SCORE_CLOSE\$/g, reservedWord.all_end_reception_total_score);
      text = text.replace(/\$TOTAL_SCORE_SETTING\$/g, reservedWord.all_question_total_score);

      var userAnswerResult = '';
      var userScore = 0;
      var userCorrectAnswerNum = 0;
      var userAnswerSelectName = '';
      var userAnswerRate = 0;

      if(cookieData && cookieData.answered_last_num) {
        var answers = cookieData.answers;

        for(const answer of answers) {

          // userAnswerResult
          if(answer.q == cookieData.answered_last_num) {
            if(answer.res == 1) {
              userAnswerResult = '〇正解';
            } else {
              userAnswerResult = '×不正解';
            }

            // userAnswerSelectName
            if(questionInfo.length && questionInfo[0].question_no == cookieData.answered_last_num) {
              for(let choice of questionInfo[0].choices_list) {
                if(choice.choice_no == answer.a) {
                  userAnswerSelectName = choice.choices;
                }
              }
            }

          }

          // userScore
          if(answer.res == 1) {
            userScore = userScore + answer.score;
            userCorrectAnswerNum ++;

            // クイズの時はスコア予約後を設問公開ステータスで分岐
            // JSONに出力されてる設問は設問公開ステータス「4」じゃなければスコア計算をマイナスする
            if(questionPublicStatus != 4 && questionNo == answer.q) {
                userScore = userScore - answer.score;
                userCorrectAnswerNum --;
            }
          }

        }
          // userAnswerRate
          if(reservedWord.now_question_num == 1 && questionPublicStatus != 4) {
            userAnswerRate = 0;
          } else if(reservedWord.now_question_num > 1 && questionPublicStatus != 4 ) {
            userAnswerRate = Math.round(userCorrectAnswerNum / (reservedWord.now_question_num - 1) * 100);
          } else {
            userAnswerRate = Math.round(userCorrectAnswerNum / reservedWord.now_question_num * 100);
          }
      }

      text = text.replace(/\$USER_ANSWER_RESULT\$/g, userAnswerResult);
      text = text.replace(/\$USER_ANSWER_SELECT_NAME\$/g, userAnswerSelectName);
      text = text.replace(/\$USER_SCORE\$/g, userScore);
      text = text.replace(/\$USER_CORRECT_ANSWER_NUM\$/g, userCorrectAnswerNum);
      text = text.replace(/\$USER_ANSWER_RATE\$/g, userAnswerRate);

      return text;
    },

    clearTimer() {
      clearInterval(this.timerId);
    },

  }
}

/* eslint-enable */

</script>

<style lang="scss">
#app {
}
</style>
